import { BaseElement } from '@nrk/dh-server-libs/base-element'
import { getElementTag } from '@nrk/dh-server-libs/get-element-tag'

import levendeStillbilde from '@nrk/dh-basis-levende-stillbilde'
import { closest, ElementIntersectionObserver } from '@nrk/dh-basis-common'
import styles from './components/VideoLoop.module.css'

const tag = getElementTag(__APP_NAME__, __APP_VERSION__)

function safeDefine(elementName, constructor) {
  if (typeof customElements.get(elementName) === 'undefined') {
    customElements.define(elementName, constructor)
  }
}

const VIEWPORT_POSITION_ATTR = 'data-viewport-position'

class AppElement extends BaseElement {
  name = tag

  render() {
    safeDefine('dh-lvs-basis-levende-stillbilde', levendeStillbilde)
    this.sendGaEvent({ eventAction: `MOUNT:${tag}` })

    try {
      // Checks to see whether or not the video element is inside the a feature article cover
      const insideCover = Boolean(closest(this, '.article-feature__cover'))
      const captionEl = this.querySelector(`[data-caption]`)
      if (insideCover && captionEl) {
        captionEl.parentNode.replaceChild(
          headingCaption(this.preloadedState.altText, this.preloadedState.byline),
          captionEl
        )
      }

      const videoWrapperElement = this.querySelector('.dh-video-wrapper')

      // eslint-disable-next-line no-unused-vars
      const elementObserver = new ElementIntersectionObserver(
        [videoWrapperElement],
        (intersections) => {
          const element = intersections[0]
          const elementViewportPosition = videoWrapperElement.getAttribute(VIEWPORT_POSITION_ATTR)
          if (element.isIntersecting && elementViewportPosition === 'OUT-OF-VIEWPORT') {
            videoWrapperElement.setAttribute(VIEWPORT_POSITION_ATTR, 'IN-VIEWPORT')
          }
          if (!element.isIntersecting && elementViewportPosition === 'IN-VIEWPORT') {
            videoWrapperElement.setAttribute(VIEWPORT_POSITION_ATTR, 'OUT-OF-VIEWPORT')
          }
        }
      )
    } catch (err) {
      // fail silently
    }
  }
}

if (!customElements.get(tag)) {
  customElements.define(tag, AppElement)
}

function headingCaption(altText, byline) {
  const captionContainer = document.createElement('div')
  captionContainer.innerHTML = `<span class='nrk-sr'>${altText}</span><span>${byline}</span>`
  captionContainer.setAttribute('class', styles['byline'])
  captionContainer.setAttribute('data-caption', true)
  return captionContainer
}
